import React from 'react';
import Card from '../Card/Card';
import './GameBoard.css';

const GameBoard = ({ 
  cards, 
  flippedCards, 
  matchedPairs, 
  isFlashing, 
  onCardClick,
  totalPairs
}) => {
  return (
    <div className="game-board-container">
      <div className="game-board">
        {cards.map((card) => {
          const isFlipped = flippedCards.some(fc => fc.id === card.id);
          const isMatched = matchedPairs.includes(card.parId);

          return (
            <Card
              key={card.id}
              cardData={card}
              isFlipped={isFlipped}
              isFlashing={isFlashing}
              isMatched={isMatched}
              onClick={onCardClick}
            />
          );
        })}
      </div>
    </div>
  );
};

export default GameBoard;
